import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2 4.667h12a.667.667 0 1 0 0-1.334H2a.667.667 0 0 0 0 1.334m0 2.666h6.667a.667.667 0 0 0 0-1.333H2a.667.667 0 0 0 0 1.333m12.513-.873a.67.67 0 0 0-.94-.08L12.24 7.487a.668.668 0 0 0 0 1.026l1.333 1.107a.67.67 0 0 0 .71.097.667.667 0 0 0 .144-1.117l-.72-.6.72-.6a.667.667 0 0 0 .086-.94M14 11.333H2a.667.667 0 1 0 0 1.334h12a.667.667 0 0 0 0-1.334M2 10h6.667a.667.667 0 0 0 0-1.333H2A.667.667 0 1 0 2 10"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })